// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__b4CL8","title":"ClientCherryInfo_title__18OOJ","itemText":"ClientCherryInfo_itemText__V1WA1"};